import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddArticleAction } from '../../../module/action/Articles';
import Spinner from '../../../Constants/Spinner';
import BackIcon from '../../../Assets/Icons/BackIcon';
import UploadIcon from '../../../Assets/Icons/UploadIcon';
import PublishIcon from '../../../Assets/Icons/PublishIcon';
import { toast } from 'react-toastify';

function AddArticle() {
  const dispatch = useDispatch();
  const addArticleLoader = useSelector(e => e.Articles.addArticleLoader);
  const [obj, setObj] = useState({
    titleName: '',
    pdf_file: '',
  });

  const clearState = () => {
    setObj({
      titleName: '',
      pdf_file: '',
    });
  };
  // useEffect(() => {
  //     dispatch(Action())
  // }, [])

  return (
    <div className="AddArticle  my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <div className="flex items-center">
            <button
              className="bg-[#eef2f0] flex items-center justify-center w-[48px] h-[48px] rounded-xl mr-4"
              onClick={() => window.history.back()}>
              <BackIcon />
            </button>
            <h2 className="text-[32px] font-extrabold">Add New Article</h2>
          </div>
        </div>
      </div>
      <div className="w-full mt-11 flex justify-between ">
        <div className="w-full max-w-[540px]">
          <div className=" bg-[#f5f5f5] w-full p-[32px] mb-4  rounded-[10px]">
            <div className=" w-full">
              <div className="mb-4">
                <p className="text-sm text-black font-semibold">Article Title </p>
                <input
                  value={obj.titleName}
                  placeholder="Write title here"
                  className="rounded-xl mt-[16px]   w-full h-[56px] px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let data = { ...obj };
                    data.titleName = ev.target.value;
                    setObj(data);
                  }}
                />
              </div>
            </div>
            <div className=" w-full">
              <div className="mb-4">
                <p className="text-sm text-black font-semibold">PDF File</p>
                <p className="text-sm text-[#7b867c]  mt-2">Select PDF file from your computer</p>
                <label className="relative text-[#2a9134] flex mt-2 items-center">
                  <input
                    type="file"
                    accept=".pdf"
                    className="hidden w-0 absolute"
                    onChange={ev => {
                      if (ev.target.files && ev.target.files[0]) {
                        let data = { ...obj };
                        data.pdf_file = ev.target.files[0];
                        setObj(data);
                      }
                    }}
                  />
                  <div className="flex w-[150px] items-center justify-center mr-4 rounded-xl text-[#2a9134] font-semibold py-3.5 px-8 border-[1px] border-[#2a9134] bg-white">
                    <UploadIcon className="mr-1.5" />
                    Upload
                  </div>

                  {/* {a.pdfName ? */}
                  <p className="text-black text-sm font-medium font-[600] font-semibold">
                    {obj.pdf_file ? obj.pdf_file.name : 'PDF Name.pdf'}
                  </p>
                  {/* : null} */}
                </label>
              </div>
            </div>
          </div>

          <button
            disabled={addArticleLoader}
            className="relative mt-6 px-[90px] rounded-xl bg-[#2a9134] text-white py-3.5 flex items-center justify-center"
            onClick={() => {
              if (obj.titleName) {
                dispatch(AddArticleAction(obj, clearState));
              } else {
                toast.error('please add article title');
              }
            }}>
            {addArticleLoader ? <Spinner /> : null}
            <span
              className={
                addArticleLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
              }>
              <PublishIcon className="mr-2" />
              Publish
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddArticle;
